import { Button, Card, Flex } from "antd"
import dayjs from "dayjs"
import { ReactComponent as Ticket } from "../../../../../assets/images/icon/ticket.svg"
import { useNavigate } from "react-router-dom"
import { BarcodeIconWithModal } from "../../../../../features"
import { useEffect, useRef, useState } from "react"
import { useMyContext } from "../../../../../entities/context"
import { ReactComponent as Warning } from "../../../../../assets/images/icon/warning.svg"
import { ReactComponent as Outlink } from "../../../../../assets/images/icon/outlink.svg"
import ProgramBookingTicketCheckModal from "../../detail/programBookingDetail/ticketCheckModal"
import { deepLinkBridgeElseNewTab } from "../../../../../utils"
import { isIOS } from "react-device-detect"
import { useAllImagesLoaded } from "../../../../../utils/checkImgLoaded"

interface IProps {
    reservationList: Array<IGetMyReservationHistoryResponse>
}

const ConfirmReservation = ({ reservationList }: IProps) => {
    const navigate = useNavigate();
    const [barcodeModal, setBarcodeModal] = useState<boolean>(false);
    const { topHeight, setMyReservationHistoryTabKey } = useMyContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectProgram, setSelectProgram] = useState<IGetMyReservationHistoryResponse>();
    const containerRef = useRef<HTMLDivElement>(null);
    const [targetMarginTop, setTargetMarginTop] = useState<number>(0);
    const { onLoad, allLoaded } = useAllImagesLoaded(reservationList.length);
    const calcDday = (startDate: string) => {
        const start = dayjs(startDate).startOf('day');
        const today = dayjs().startOf('day');
        if (start.isSame(today, 'day')) {
            return 'D-DAY';
        }

        const diff = start.diff(today, 'day');
        if (diff > 0) {
            return `D-${diff}`;
        } else {
            return `D+${Math.abs(diff)}`;
        }
    };

    useEffect(() => {
        setMyReservationHistoryTabKey(1)
    }, [])

    useEffect(() => {
        if (!containerRef.current) return;
        const targetHeight = containerRef.current.offsetHeight + 24 + 90 + (Number(topHeight) ?? 0);
        const targetValue = window.innerHeight > targetHeight ? window.innerHeight - targetHeight - 28 - (isIOS ? 46 : 20) : 32;
        setTargetMarginTop(targetValue < 0 ? 0 : targetValue)
    }, [reservationList, allLoaded])
    console.log('reservationList', reservationList)
    return <>
        <div ref={containerRef}>
            {reservationList.length === 0
                ? <div style={{ paddingTop: '75%', textAlign: 'center' }}>
                    <div className="body/b2 secondary/s800">확정된 프로그램이 없습니다.</div>
                    <div style={{ marginTop: 8 }}>
                        <Button className="sub-title/st2 secondary/s600" style={{ border: '1px solid var(--secondarys400)', borderRadius: '4px' }} color="default" variant="outlined" onClick={() => navigate('/explore')}> 프로그램 둘러보기</Button>
                    </div>
                </div >
                : reservationList.map((reservation: IGetMyReservationHistoryResponse) =>
                    <Card
                        key={reservation.reservationId + reservation.programBookingId}
                        className="custom-card"
                        onClick={() => {
                            if (barcodeModal) return;
                            reservation.isProgram ? navigate(`/program/book/detail/${reservation.reservationId}`) : navigate(`/lecture/${reservation.wellnessLectureId}`)
                        }}
                        style={{ width: '100%', marginBottom: 32, border: 'none', boxShadow: '0px 0px 16px 0px #0000001A' }}
                        cover={<>
                            <img alt="example" src={reservation.imageUrl} style={{ maxHeight: 160, objectFit: 'cover' }} onLoad={onLoad} />
                            {reservation.status !== '취소 요청' && <div className="sub-title/st1 base/white" style={{ position: 'absolute', top: 11.74, left: 12, backgroundColor: 'var(--dimd200)', width: 'auto', borderRadius: 'var(--radius4)', padding: '3.78px var(--space4)' }}>{calcDday(reservation.startDateTime)}</div>}
                        </>}
                    >
                        <Flex style={{ alignItems: 'center', gap: 6 }}>
                            <div className="sub-title/st4">{reservation.title}</div>
                            {!!reservation.guestCount && <div className="caption/c1 secondary/s600" style={{ padding: '2px 6px', border: '1px solid var(--secondarys300)', borderRadius: 4 }}>게스트 {reservation.guestCount}명</div>}
                        </Flex>
                        <Flex justify="space-between" style={{ marginTop: 20, alignItems: 'center' }}>
                            <div className="secondary/s500">
                                <div>{dayjs(reservation.startDateTime).format('YYYY.MM.DD (dd) HH:mm')}</div>
                                <div>{(reservation.teacherName !== null && reservation.teacherName !== '') ? reservation.teacherName + ' 코치' : ''} {reservation.yogaCenterName}</div>
                            </div>
                            {reservation.isProgram
                                ? reservation.status === '취소 요청'
                                    ? <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                                        <Warning width={16} height={16} fill="#7D7D7D" />
                                        <div className="caption/c1 secondary/s600">취소 요청중</div>
                                    </div>
                                    : reservation.isOnline
                                        ? <Outlink width={24} height={24} stroke="#7D7D7D" style={{ padding: 10 }} onClick={(event) => { event.preventDefault(); event.stopPropagation(); deepLinkBridgeElseNewTab(reservation.onlineUrl) }} />
                                        : <Ticket width={24} height={24} style={{ padding: 10 }} onClick={event => { event.preventDefault(); event.stopPropagation(); setSelectProgram(reservation); setIsModalOpen(true) }} />
                                : <BarcodeIconWithModal style={{ padding: 10 }} setPropsState={setBarcodeModal} onClick={event => { event.preventDefault(); event.stopPropagation(); }} color={'var(--secondarys400)'} />}
                        </Flex>
                    </Card>
                )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: targetMarginTop, paddingBottom: isIOS ? 46 : 20 }}>
            <div className="btn/text-btn secondary/s600" >
                <div>예약 내역이 안보이시나요?</div>
                <div style={{ textDecoration: 'underline', textAlign: 'center' }} onClick={() => deepLinkBridgeElseNewTab('https://pf.kakao.com/_xmWxbYG/chat')}>컨시어지로 문의해주세요.</div>
            </div>
        </div>
        {selectProgram?.isProgram && <ProgramBookingTicketCheckModal key={selectProgram?.programBookingId} open={isModalOpen} setOpen={setIsModalOpen} programBookingId={selectProgram?.programBookingId} imageUrl={selectProgram?.programThumbnailImageUrl ?? ''} />}
    </>
}

export default ConfirmReservation